<template>
  <vue-scroll class="page-payment-provider">
    <div class="page-header">
      <h1><i :class="'mdi mdi-' + $route.meta.icon"></i> {{ $route.name }}</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="card-base card-shadow--medium p-30">
      <el-row :gutter="50">
        <el-col :span="8" :xs="24">
          <form-component/>
        </el-col>
        <el-col :span="16" :xs="24">
          <list-component/>
        </el-col>
      </el-row>
    </div>
  </vue-scroll>
</template>

<script>
import ListComponent from './List.vue'
import FormComponent from './Form.vue'

export default {
  name: 'AdminTable',
  components: { ListComponent, FormComponent }
};
</script>

